import RouteConstant from '@/constant/RouteConstant';
import useToggle from '@/hook/useToggle';
import { onAccountDrawerClose } from '@/redux/slices/app';
import { getToken } from '@/redux/slices/user';
import { dispatch } from '@/redux/store';
import { SettingsContext } from '@/SettingsProvider';
import { changeLocale } from '@/utils/dateUtils';
import { getUrlParams } from '@/utils/utils';
import { Box, styled } from "@mui/material";
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PromoView from './components/PromoViewSonic';
import { fbLogEventDefaultParams, FB_EVENT_TYPES } from '@/utils/firebase';

const StyledBox = styled(Box)(({theme}) => ({
  background: 'url(/images/sonic-bg.svg) no-repeat center',
  backgroundSize: '100% 100%',
}))

function Welcome() {
  const navigate = useNavigate();
  const {
    toggle: showPromo,
    onToggle: onToggleShowPromo,
    setToggle: setToggleShowPromo,
  } = useToggle(true);
  const { t, i18n } = useTranslation();

  const {
    updateSetting,
    settings,
  } = useContext(SettingsContext)
  const [mode, setMode] = useState(null);

  useEffect(() => {
    if (getToken()) {
      navigate(RouteConstant.MAIN);
    } else {
      const mode = getUrlParams('mode');
      if (mode) {
        setToggleShowPromo(false);
        setMode(mode);
      }
    }
    setTimeout(() => {
      fbLogEventDefaultParams(FB_EVENT_TYPES.LOADED,{ pageName:"welcome" })
    },50);
  }, []);

  useEffect(() => {
    let lang = getUrlParams('lang');
    // 如果params 包含lang，设置语言
    if (lang) {
      handleChangeLanguage(lang);  
    }

    dispatch(onAccountDrawerClose());
  }, []);

  const handleChangeLanguage = (language) => {
    const newSettings = {
      lang: language,
    }

    // ar will using rtl direction layout.
    if (language === 'ar') {
      newSettings.direction = 'rtl'
    } else {
      newSettings.direction = 'ltr'
    }

    i18n.changeLanguage(language)
    changeLocale(language)
    updateSetting(newSettings)
  }

  const _onPromoGoTo = () => {
    fbLogEventDefaultParams(FB_EVENT_TYPES.LOGIN_OR_REGISTER_CLICK,{ pageName:"welcome" })
    navigate({
      pathname: RouteConstant.LOGIN,
      search: window.location.search,
    });
  }

  return (
    <StyledBox>
      <PromoView onGoTo={_onPromoGoTo}/>
    </StyledBox>
  );
}

export default Welcome;
